export default "__VITE_ASSET__CpeE34Y8__"